//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { PrimaryAnchor } from '@components/atoms/anchor/Anchor';
import { BodyText } from '@components/atoms/text/Text';

const currentYear = new Date().getFullYear();

const FooterLinksData = [
  {
    href: 'https://docs.bazaarvoice.com/home/en-us/?redirect=yes',
    label: 'Knowledge Base',
  },
  { href: 'https://www.bazaarvoice.com/legal/', label: 'Legal' },
  {
    href: 'https://www.bazaarvoice.com/legal/privacy-policy/',
    label: 'Privacy Policy',
  },
] as const;

export const LoginFooter = () => {
  return (
    <Footer>
      <FooterLinks>
        {FooterLinksData.map((link) => (
          <PrimaryAnchor key={link.href} href={link.href}>
            {link.label}
          </PrimaryAnchor>
        ))}
      </FooterLinks>
      <BodyText>© {currentYear} Bazaarvoice. All rights reserved.</BodyText>
    </Footer>
  );
};

const Footer = styled.footer(
  ({ theme }) => `
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: ${theme.colors.gray00};
  color: ${theme.colors.black};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: ${theme.spacings[3]} ${theme.spacings[5]};
  height: ${theme.spacings[7]};
`,
);
const FooterLinks = styled.div(
  ({ theme }) => `
  display: flex;
  gap: ${theme.spacings[4]};
`,
);
